import React from 'react';
import { styled } from '@mui/material/styles';
import { OutlinedInput, FormHelperText } from '@mui/material';

const CustomOutlinedInput = styled((props) => <OutlinedInput {...props} />)(({ theme }) => ({
  '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '0.8',
  },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.error.main,
  },
}));

const CustomInputWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
}));

const CustomHelperText = styled(FormHelperText)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  bottom: -20, // Adjust this value as needed to position the helper text properly
}));

const CustomOutlinedInputWithValidation = ({ error, helperText, ...props }) => (
  <CustomInputWrapper>
    <CustomOutlinedInput {...props} error={error} />
    {error && <CustomHelperText error>{helperText}</CustomHelperText>}
  </CustomInputWrapper>
);

export default CustomOutlinedInputWithValidation;
